/**
 * Online and hybrid dates add the viewer's local time after mount, only when it differs from the event
 * session's zone (spec §3.7 Times; design: "9:00 to 10:00 AM PDT your time"). Nothing in the static render.
 */
import { useEffect, useState } from "react";
import { localRange } from "../lib/time";

export function useLocalRange(local) {
  const [text, setText] = useState(null);
  useEffect(() => {
    if (!local) { setText(null); return; }
    try {
      const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      const r = localRange(local, viewerTz);
      setText(r ? `${r} your time` : null);
    } catch { setText(null); } // an unknown zone: leave the event session's time alone
  }, [local?.starts_at, local?.ends_at, local?.timezone]); // eslint-disable-line
  return text;
}

export function LocalTime({ local }) {
  const text = useLocalRange(local);
  if (!text) return null;
  return <span className="ev-local" data-local-time="">{text}</span>;
}
